//import React from "react";
import { Navigate, NavigateFunction, Route, RouteObject } from "react-router-dom";
import { Autopig, Autopig_settings, Freeda_lf, Freeda_lf_sections, Freeda_lf_settings } from "../../../Containers/index"
import TabMenu from "../../Menus/tabMenu";

// TODO
import Freeda_esf_settings from "../../../Containers/CloudScreens/SystemScreens/Freeda_esf/freeda_esf_settings";
import Freeda_esf_sections from "../../../Containers/CloudScreens/SystemScreens/Freeda_esf/freeda_esf_sections";
import Freeda_esf from "../../../Containers/CloudScreens/SystemScreens/Freeda_esf/freeda_esf";

/* eslint-disable */
export enum Pages {
  home="./",

  autopig="autopig",
  Autopig_settings="settings",

  freeda_lf="lf",
  freeda_lf_sections="lf sections",
  // freeda_lf_section="section",
  freeda_lf_settings = "lf settings",
  
  freeda_esf = "esf",
  freeda_esf_sections = "esf sections",
  freeda_esf_settings = "esf settings"
}
/* eslint-enable */

export const Router = [ //...SystemMenuRouter,
    { path:`/${Pages.autopig}/:systemId`, element:<TabMenu main={Pages.autopig} overrides={{base_alternative:Pages.home}} contexts={[ Pages.Autopig_settings ]} />,
      children:[
        { index:true, Component:Autopig },
        { path: `${Pages.Autopig_settings}`, Component:Autopig_settings },
        { path: `*`, element: <Navigate to={`/${Pages.autopig}`} />}
      ]
    },
    { path:`/${Pages.freeda_lf}/:systemId`, element:<TabMenu main={Pages.freeda_lf} overrides={{base_alternative:Pages.home}} contexts={[ Pages.freeda_lf_sections, Pages.freeda_lf_settings ]} />,
      children:[
        { index:true, Component:Freeda_lf },
        { path:`${Pages.freeda_lf_sections}`, Component:Freeda_lf_sections },
        { path:`${Pages.freeda_lf_settings}`, Component:Freeda_lf_settings }
      ]
    },
    { path:`/${Pages.freeda_esf}/:systemId`, element:<TabMenu main={Pages.freeda_esf} overrides={{base_alternative:Pages.home}} contexts={[ Pages.freeda_esf_sections, Pages.freeda_esf_settings ]} />,
    children:[
      { index:true, Component:Freeda_esf },
      { path:`${Pages.freeda_esf_sections}`, Component:Freeda_esf_sections },
      { path:`${Pages.freeda_esf_settings}`, Component:Freeda_esf_settings }
    ]
  },
  ] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page: Pages, navigation_sub?: Pages, navArgs?: Object) => {
  const selected = navArgs && "selected" in navArgs && typeof navArgs.selected === "number" && navArgs.selected ? navArgs.selected : 0;
  const systemIdFromParams = navArgs && "systemId" in navArgs && typeof navArgs.systemId === "string" && navArgs.systemId ? navArgs.systemId : undefined;
  const systemId = systemIdFromParams ? systemIdFromParams : selected;
  const navigation = systemIdFromParams ? {selected: +systemId} : navArgs;
  switch (navigation_page) {
    case Pages.home:
      Navigator(Pages.home, {state:{}})
    break
    case Pages.autopig:
      switch (navigation_sub) {
        case Pages.Autopig_settings:
          Navigator(`/${Pages.autopig}/${Pages.Autopig_settings}`, {state:{tab:1, ...navigation}})
        break
        default:
          Navigator(`/${Pages.autopig}`, {state:{tab:0, ...navigation}})
      }
    break
    case Pages.freeda_lf:
      switch (navigation_sub) {
        case Pages.freeda_lf_sections:
          Navigator(`/${Pages.freeda_lf}/${systemId}/${Pages.freeda_lf_sections}`, {state:{tab:1, params:{...navigation}}})
        break
        case Pages.freeda_lf_settings:
          Navigator(`/${Pages.freeda_lf}/${systemId}/${Pages.freeda_lf_settings}`, {state:{tab:2, params:{...navigation}}})
        break
        default:
          Navigator(`/${Pages.freeda_lf}/${systemId}`, {state:{tab:0, ...navigation}})
      }
      break
      case Pages.freeda_esf:
        switch (navigation_sub) {
          case Pages.freeda_esf_sections:
            Navigator(`/${Pages.freeda_esf}/${Pages.freeda_esf_sections}`, {state:{tab:1, ...navigation}})
          break
          case Pages.freeda_esf_settings:
            Navigator(`/${Pages.freeda_esf}/${Pages.freeda_esf_settings}`, {state:{tab:2, ...navigation}})
          break
          default:
            Navigator(`/${Pages.freeda_esf}`, {state:{tab:0, ...navigation}})
        }
      break
    default:
      console.log("Error page not found (404)???, [SystemMenu]")
  }
}